<footer class="tw-footer">
    <ul class="tw-footer__list">
        <li class="tw-footer__item" *ngFor="let item of listLink">
            <a href="{{item.href}}" title="{{item.link}}" class="tw-footer__link" *ngIf="item.info != true">{{item.link}}</a>
                <span class="tw-footer__txt" *ngIf="item.info == true">{{item.link}}</span>
        </li>
    </ul>
</footer>
